import React, { Fragment } from 'react'
import { PassengerForm } from './passenger-form.component'
import Yup from '../../../helpers/custom-yup'
import BusSeatSelectionSelectors from '../../../selectors/bus-seat-selection.selectors'
import { connect } from 'react-redux'
import { toastActions } from '../../../actions/toast.actions'
import { PassengerService } from '../../../services/passenger.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import './styles/passengers-data.style.css'

class PassengersDataComponent extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			namePassenger: '',
			documentType: '',
			documentNumber: '',
			passengers: [],
			positionOne: 0,
			positionTwo: 0,
			positionThree: 0,
			positionFour: 0,
			activePassengers: [],
			showToggleLoggedPassenger: true,
			loggedPassengerAlreadySet: false,
		}

		this.timeOut = null

		this.initialValues = {
			docname: null,
			docnumber: null,
			doctype: null,
		}

		this.schema = Yup.object().shape({
			docname: Yup.string()
				.name()
				.nullable()
				.required('Informe o nome completo'),
			doctype: Yup.string()
				.required('Informe o tipo de documento')
				.nullable(),
			docnumber: Yup.string().when('doctype', {
				is: 'Cpf',
				then: Yup.string().cpf().required('Informe o número do documento'),
				otherwise: Yup.string()
					.required('Informe o número do documento')
					.nullable(),
			}),
		})

		this.loadOptions = loadOptions.bind(this)
		this.setPassengers = setPassengers.bind(this)
		this.addActivePassenger = addActivePassenger.bind(this)
		this.addAndRemoveActualPassenger = addAndRemoveActualPassenger.bind(this)
		this.removeActivePassenger = removeActivePassenger.bind(this)
	}
	componentWillUnmount() {
		clearTimeout(this.timeOut)
	}

	componentDidMount() {
		this.props.getFormsRefs(() =>
			Object.values(this.refs).map((form) => {
				return form._reactInternalFiber.child.stateNode.refs.form
			})
		)
		this.props.user !== null ? this.loadOptions() : null
	}

	handleDocTypeChange = (value) => {
		this.setState({ documentType: value })
	}

	setShowToggleLoggedPassenger = (option) => {
		this.setState({ showToggleLoggedPassenger: option })
	}

	setLoggedPassengerAlreadySet = (option) => {
		this.setState({ loggedPassengerAlreadySet: option })
	}

	render() {
		const {
			user,
			onSubmit,
			numberOfPassengers,
			selectedPriceGoing,
			selectedPriceReturn,
		} = this.props

		return (
			<div>
				{Array.from({ length: numberOfPassengers }).map((_, index) => (
					<PassengerForm
						upcomingPassenger={this.state.upcomingPassenger}
						key={index}
						passengers={this.state.passengers}
						position={index}
						loadOptions={this.loadOptions}
						setPassengers={this.setPassengers}
						addActivePassenger={this.addActivePassenger}
						removeActivePassenger={this.removeActivePassenger}
						addAndRemoveActualPassenger={this.addAndRemoveActualPassenger}
						setShowToggleLoggedPassenger={
							this.setShowToggleLoggedPassenger
						}
						showToggleLoggedPassenger={
							this.state.showToggleLoggedPassenger
						}
						setLoggedPassengerAlreadySet={
							this.setLoggedPassengerAlreadySet
						}
						loggedPassengerAlreadySet={
							this.state.loggedPassengerAlreadySet
						}
						ref={`form${index}`}
						formTitle={`Passageiro ${index + 1}`}
						{...{
							selectedPriceGoing,
							selectedPriceReturn,
							onSubmit,
							user,
						}}
					/>
				))}
			</div>
		)
	}
}

function addActivePassenger(passenger) {
	this.setState({
		activePassengers: [...this.state.activePassengers, passenger],
	})
}

function removeActivePassenger(passenger) {
	const newActivePassengers = this.state.activePassengers.filter((p) => {
		return p.value.documentNumber !== passenger.documentnumber
	})

	this.setState({ activePassengers: newActivePassengers })
}

function addAndRemoveActualPassenger(remove, add) {
	const newActivePassengers = this.state.activePassengers.filter((p) => {
		return p.value.documentNumber !== remove.documentnumber
	})

	this.setState({ activePassengers: [...newActivePassengers, add] })

	return new Promise((resolve, reject) => {
		setTimeout(() => {
			resolve(this.state.activePassengers)
		}, 300)
	})
}

function setPassengers(func) {
	func(this.state.passengers)
}

function loadOptions(index, position) {
	PassengerService.getPassengers().then(({ data }) => {
		if (!data) {
			return
		}

		const options = data.map((data) => ({
			value: data,
			label: data.name,
		}))

		if (index) {
			position === 0
				? this.setState({ positionOne: index })
				: position === 1
				? this.setState({ positionTwo: index })
				: position === 2
				? this.setState({ positionThree: index })
				: position === 3
				? this.setState({ positionFour: index })
				: null

			const usedIndex = [
				this.state.positionOne,
				this.state.positionTwo,
				this.state.positionThree,
				this.state.positionFour,
			]

			const actuals = options.filter((op) => {
				let finded = usedIndex.findIndex((usedIndex) => {
					return usedIndex === op.value.id
				})
				return finded === -1
			})

			const withNoUse = actuals.filter((ac) => {
				let finded = this.state.activePassengers.findIndex((ap) => {
					return ap.value.documentNumber === ac.value.documentNumber
				})
				return finded === -1
			})

			this.setState({ passengers: withNoUse })
		} else {
			const withNoUse = options.filter((op) => {
				let finded = this.state.activePassengers.findIndex((ap) => {
					return ap.value.documentNumber === op.value.documentNumber
				})
				return finded === -1
			})

			this.setState({ passengers: withNoUse })
		}
	})
}

const mapStateToProps = ({ ticketSale, busSeatSelection, user }) => ({
	user,
	selectedPriceGoing: ticketSale.selectedPriceGoing,
	selectedPriceReturn: ticketSale.selectedPriceReturn,
	numberOfPassengers:
		BusSeatSelectionSelectors.getNumberOfPassengers(busSeatSelection),
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
		},
		dispatch
	)

const PassengersData = connect(
	mapStateToProps,
	mapDispatchToProps
)(PassengersDataComponent)

export default PassengersData
